
import React, { useState } from "react";
 import img01 from "./../../../assets/images/283.png";// Adjust the path as necessary
 
 function ObjectivesOfWelfareProgramme() {
     
   return (
     <>
       <div className="service-title font-700 mb-3 text-uppercase">
        Objectives of 
          <span className="text-orange-ef3e33 font-400"> the seafarer welfare programme:
          </span>
       </div>
 
       <div className="row g-3 g-sm-4 g-md-5">
         <div className="col-lg">
            <div className="service-title font-700 mb-3 text-uppercase">
            </div>
 
           {/* <p className="text-primary-color mb-3">Working on board vessels is regarded as one of the most challenging jobs in the world, as seafarers find themselves away from families for extended periods of time whilst sailing in often treacherous conditions. This makes working at sea not just a dangerous job but also a mentally stressful environment. Seafarers are also often unable to communicate with families and friends for extended periods until they are in a port. The nature of the job isolates the individuals from their social and security net. This then make those working on board vessels vulnerable or compromised when it comes to safety, security and working conditions. </p> */}

            <ul class="green-star-ul">
                                      <li>Give effect to the seafarer welfare provisions under the MLC and C188.                                        
                                      </li>
                                      <li>Give effect to the seafarer welfare provisions under the MLC and C188.
                                      </li>
                                      <li>Provide a one-stop shop for all issues related to seafarer welfare for the convenience of seafarers.
                                      </li>
                                      <li>Centralise seafarer welfare complaints including labour related issues.
                                      </li>
                                      <li>Provide an informative platform for all South African seafarers including foreign seafarers visiting our ports. 
                                      </li>
                                      <li>Make South African ports and harbours a haven for visiting seafarers
                                      </li>
                                      <li>Provide guidelines to the industry on seafarer welfare including GBV, violence and harassment, including sexual harassment, bullying and sexual assault.
                                      </li>
                                      <li>Provide primary counselling and referral services to seafarers in need of the service.
                                      </li>
                                      <li>Provide guidance to South African seafarers wherever they are.
                                     </li>                                      
                                      </ul>
           {/* <ul class="green-star-ul">
             <li>In reporting Crew complaints that falls within MLC kindly ensure that you have followed the guidelines provided in Marine Notice No. 48 of 2020 – Onboard Complaints Procedure. </li>
               
           </ul>   */}
           
                
 
         </div>
         {/* <div className="col-lg-5">
           <div className="row g-3 g-sm-3 g-md-4 g-lg-4">
             <div className="col-lg-12 col-md-6 col-sm-6">
               <img src={img01} className="img-fluid rounded-1" alt="" />
             </div>
             <div className="col-lg-12 col-md-6 col-sm-6">
               <img src={img01} className="img-fluid rounded-1" alt="" />
             </div>
           </div>        
         </div> */}
         



          
       </div>
       {/* <ul class="green-star-ul">
             <li>In reporting Crew complaints that falls within MLC kindly ensure that you have followed the guidelines provided in Marine Notice No. 48 of 2020 – Onboard Complaints Procedure. </li>
             
             <li>In reporting complaints falling outside the MLC i.e. fishing vessels, report the complaint to the company by following company’s procedures and if not satisfied contact any SAMSA office nearest to you, alternatively you can forward your complaint to welfare@samsa.org.za </li>
                  
           </ul>   */}
       <br/>

            <p className="text-primary-color"></p>
 
     </>
   );
 }
 
export default ObjectivesOfWelfareProgramme;